import { type ReactNode } from 'react';

type Variant = 'danger' | 'warning' | 'success' | 'info' | 'neutral';

const STYLES: Record<Variant, { bg: string; glow: string }> = {
  danger: {
    bg: 'bg-red-900/30 text-red-400 border border-red-800/40',
    glow: '0 0 8px rgba(239,68,68,0.25)',
  },
  warning: {
    bg: 'bg-amber-900/30 text-amber-400 border border-amber-800/40',
    glow: '0 0 8px rgba(251,191,36,0.25)',
  },
  success: {
    bg: 'bg-emerald-900/30 text-emerald-400 border border-emerald-800/40',
    glow: '0 0 8px rgba(52,211,153,0.25)',
  },
  info: {
    bg: 'bg-cyan-900/30 text-cyan-400 border border-cyan-800/40',
    glow: '0 0 8px rgba(34,211,238,0.25)',
  },
  neutral: {
    bg: 'bg-mono-800 text-mono-300 border border-mono-700/40',
    glow: 'none',
  },
};

interface Props {
  variant: Variant;
  children: ReactNode;
  pulse?: boolean;
  className?: string;
}

export function GlowBadge({ variant, children, pulse = false, className = '' }: Props) {
  const s = STYLES[variant];
  return (
    <span
      className={`inline-block px-1.5 py-0.5 text-xs tracking-wider rounded ${s.bg} ${pulse ? 'animate-pulse-glow' : ''} ${className}`}
      style={{ boxShadow: s.glow }}
    >
      {children}
    </span>
  );
}